export default __webpack_public_path__ + "images/Visa.8aad896c93c3ab481a89590039589fd5.svg";